import React from 'react';
import AdaptiveCardRenderer from '../AdaptiveCardRenderer';

const Attachment = ({ content, contentUrl, contentType, name,isArabic,setScript,id,surveyData,disableSend }) => {
  console.log(isArabic)
  console.log('Find correct card',content)
  switch (contentType) {
    case 'image/gif':
    case 'image/jpeg':
    case 'image/png':
    case 'image/svg':
    case 'image/svg+xml':
      return <img alt={name} src={contentUrl} />;

    case 'text/markdown':
    case 'text/plain':
      return <p>{content}</p>;

    case 'application/vnd.microsoft.card.adaptive':
      if (isArabic) {
        if (content?.actions?.[0]?.title?.toLowerCase() === "login") {
          content.actions[0].title = "تسجيل الدخول"; // Remove optional chaining here
        }
        if (content?.body?.[0]?.title?.toLowerCase() === "pay now") {
          content.body[0].title = "ادفع الآن"; // Remove optional chaining here
        }
      }
      return <div style={{ paddingTop:"16px",paddingBottom:"16px" }}>
      <AdaptiveCardRenderer
        cardData={content}
        setScript={setScript}
        isArabic={isArabic}
        id={id}
        surveyData={surveyData}
        disableSend={disableSend}
      />
    </div>

    default:
      if (contentUrl) {
        return (
          <a href={contentUrl} rel="noopener noreferrer" target="_blank">
            {name}
          </a>
        );
      } else {
        return <pre>{JSON.stringify(content, null, 2)}</pre>;
      }
  }
};

export default Attachment;